module.exports = __webpack_public_path__ + "img/header-tours.0681f547.jpg";